import React from 'react';
import { Brain, Target, LineChart, Zap } from 'lucide-react';

const SmartPersonalizationPage = () => {
  return (
    <div className="pt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Smart Personalization
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our AI-powered personalization engine analyzes customer behavior to deliver the right message at the right time.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16">
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <Brain className="h-12 w-12 text-purple-600 mb-6" />
            <h3 className="text-2xl font-bold mb-4">Behavioral Analysis</h3>
            <p className="text-gray-600">
              Our AI engine analyzes customer interactions, purchase history, and engagement patterns to create detailed behavioral profiles.
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <Target className="h-12 w-12 text-blue-600 mb-6" />
            <h3 className="text-2xl font-bold mb-4">Dynamic Segmentation</h3>
            <p className="text-gray-600">
              Automatically group customers into segments based on their interests, behaviors, and preferences.
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <LineChart className="h-12 w-12 text-green-600 mb-6" />
            <h3 className="text-2xl font-bold mb-4">Predictive Analytics</h3>
            <p className="text-gray-600">
              Forecast customer behavior and optimize campaign timing for maximum impact.
            </p>
          </div>
          
          <div className="bg-white p-8 rounded-xl shadow-lg">
            <Zap className="h-12 w-12 text-amber-600 mb-6" />
            <h3 className="text-2xl font-bold mb-4">Real-time Optimization</h3>
            <p className="text-gray-600">
              Continuously improve campaign performance with real-time adjustments based on customer responses.
            </p>
          </div>
        </div>

        <div className="bg-purple-50 rounded-2xl p-8 md:p-12">
          <h2 className="text-3xl font-bold mb-6">The Power of AI Personalization</h2>
          <div className="space-y-6">
            <div className="flex items-start">
              <div className="flex-shrink-0 h-6 w-6 rounded-full bg-purple-600 flex items-center justify-center text-white text-sm">
                1
              </div>
              <div className="ml-4">
                <h4 className="text-xl font-semibold mb-2">Increased Engagement</h4>
                <p className="text-gray-600">
                  Personalized emails see up to 6x higher transaction rates than generic messages.
                </p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="flex-shrink-0 h-6 w-6 rounded-full bg-purple-600 flex items-center justify-center text-white text-sm">
                2
              </div>
              <div className="ml-4">
                <h4 className="text-xl font-semibold mb-2">Better Conversion</h4>
                <p className="text-gray-600">
                  AI-optimized campaigns achieve 40% higher conversion rates on average.
                </p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="flex-shrink-0 h-6 w-6 rounded-full bg-purple-600 flex items-center justify-center text-white text-sm">
                3
              </div>
              <div className="ml-4">
                <h4 className="text-xl font-semibold mb-2">Time Savings</h4>
                <p className="text-gray-600">
                  Automated personalization saves marketing teams an average of 20 hours per week.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartPersonalizationPage;